module.exports = __webpack_public_path__ + "img/Prescription-512.aec431b1.png";